import { Helmet } from "react-helmet-async";

export default function Seo({ seo }) {
  if (!seo) return null;

  return (
    <Helmet>
      <title>{seo.title}</title>

      <meta
        name="description"
        content={seo.description || ""}
      />

      {seo.canonical && (
        <link
          rel="canonical"
          href={seo.canonical}
        />
      )}
    </Helmet>
  );
}